import Immutable from 'immutable';

const initialState = Immutable.Map();

function logoutStarted(state, _payload) {
  return state.merge({
    logout: {
      completed: false,
      failed: false,
      errors: {},
      loading: true,
    },
  });
}

function logoutCompleted(state, _payload) {
  return state.merge({
    logout: {
      completed: true,
      failed: false,
      errors: {},
      loading: false,
    },
  });
}

function logoutFailed(state, payload) {
  return state.merge({
    logout: {
      completed: false,
      failed: true,
      errors: payload.errors,
      loading: false,
    },
  });
}

function toggleOnlineFilter(state) {
  const isOnlineFilterSelected = state.getIn([
    'user',
    'calendar_customization',
    'is_online_filter_selected',
  ]);
  return state.setIn(
    ['user', 'calendar_customization', 'is_online_filter_selected'],
    !isOnlineFilterSelected
  );
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        SESSION_LOGOUT: logoutStarted,
        SESSION_LOGOUT_COMPLETED: logoutCompleted,
        SESSION_LOGOUT_FAILED: logoutFailed,
        ONLINE_FILTER_TOGGLED: toggleOnlineFilter,
      }[type] || (() => state)
    )(state, payload);
  });
}
